import React from 'react'

export interface ArrowUpIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ArrowUpIcon: React.FC<ArrowUpIconProps> = ({
  size = '1em',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 5v14m6-8l-6-6m-6 6l6-6"
      />
    </svg>
  )
}
